module.exports = __webpack_public_path__ + "img/banner_3.41363640.png";